import { Metadata, CaptureWithContext } from '.'

type FormErrorMetadata = Metadata & {
  errorMessage?: string
}

const EVENT_CATEGORY = 'form'
const FORM_SUBMITTED = 'form_submitted'
const FORM_FAILED = 'form_failed'

export const trackFormSuccess =
  (capture: CaptureWithContext) => (metadata: Metadata) =>
    capture(FORM_SUBMITTED, {
      ...metadata,
      category: EVENT_CATEGORY,
    })

export const trackFormError =
  (capture: CaptureWithContext) => (metadata: FormErrorMetadata) =>
    capture(FORM_FAILED, {
      ...metadata,
      category: EVENT_CATEGORY,
    })
